import { View } from '../base/View';
import { ensureElement } from '../../utils/utils';
export class Page extends View {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._pageWrapper = ensureElement('.page__wrapper');
    }
    set locked(value) {
        if (value) {
            this._pageWrapper.classList.add('page__wrapper_locked');
        }
        else {
            this._pageWrapper.classList.remove('page__wrapper_locked');
        }
    }
}
